// Re-export dist/react
module.exports = require('./dist/react');
